var _polygon, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 173.2,55 173.2,145 100,190 26.8,145 26.8,55",
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 45,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 72.5,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 127.5,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 127.5,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 72.5,
    r: 15,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewHexagon);
export default __webpack_public_path__ + "static/media/preview-hexagon.02eb66cb00dcc88b2065a864a1f87089.svg";
export { ForwardRef as ReactComponent };